import HydraEntityInterface from "../interfaces/HydraEntityInterface";
import "reflect-metadata";

export default abstract class HydraEntity implements HydraEntityInterface {}
